import { ProfileAbout } from './ProfileAbout';
import { ProfileBackButton } from './ProfileBackButton';
import { ProfileBadges } from './ProfileBadges';
import { ProfileExpertises } from './ProfileExpertises';
import { ProfileHeroSection } from './ProfileHeroSection';
import { ProfileInstantMatchButtons } from './ProfileInstantMatchButtons';
import { ProfileRating } from './ProfileRating';
import { ProfileRecomendations } from './ProfileRecomendations';
import { ProfileShortAbout } from './ProfileShortAbout';

export {
  ProfileAbout,
  ProfileBackButton,
  ProfileBadges,
  ProfileExpertises,
  ProfileHeroSection,
  ProfileInstantMatchButtons,
  ProfileRating,
  ProfileRecomendations,
  ProfileShortAbout,
};
